// extracted by mini-css-extract-plugin
module.exports = {"cls1":"ReactPlayground-StyledContainer-module--cls1--1Jg9m","cls2":"ReactPlayground-StyledContainer-module--cls2--3Uz4N ReactPlayground-StyledContainer-module--cls1--1Jg9m"};